import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import "./ev-loans.css";

export default function EvApplyPage() {
  return <div className="page-wrapper modern-ui"><div className="content container-fluid">
    <h3 className="mb-4">Apply EV loan</h3>
    <div className="ev-apply-hero">
      <div className="ev-apply-hero__actions">
        <Link className="btn btn-primary" to={all_routes.evCustomerCreate}>Add EV customer</Link>
        <Link className="btn btn-primary" to={all_routes.evCustomerLoans}>Add EV loan</Link>
      </div>
    </div>
  </div></div>;
}
